// extracted by mini-css-extract-plugin
export default {"cancelButton":"dialog_cancelButton__i3Hpl","confirmButton":"dialog_confirmButton__oCQg8","textfields":"dialog_textfields__fH3Gf","textfield":"dialog_textfield__K2TU0"};